import { Card } from '../ui/Card';
import { fmt } from '../../lib/format';
import type { CalculatorResults } from '../../lib/types';

interface Props {
  results: CalculatorResults;
}

export function PaymentBreakdownCard({ results }: Props) {
  const { totalMonthly, breakdownItems } = results;
  const positiveTotal = breakdownItems.filter(i => i.value > 0).reduce((s, i) => s + i.value, 0);

  return (
    <Card title="Total Monthly Payment">
      <div className="total-payment">
        <div className="amount">${fmt(totalMonthly)}</div>
        <div className="subtitle">Estimated total monthly payment</div>
      </div>

      <div className="bar-chart">
        {breakdownItems.filter(i => i.value > 0).map(item => (
          <div
            key={item.label}
            style={{
              width: `${(item.value / positiveTotal * 100).toFixed(1)}%`,
              background: item.color,
            }}
            title={item.label}
          />
        ))}
      </div>

      <div className="card-body">
        <ul className="breakdown-list">
          {breakdownItems.map(item => (
            <li key={item.label}>
              <span className="item-label">
                <span className="dot" style={{ background: item.color }} />
                {item.label}
              </span>
              <span className="item-value">
                {item.value < 0 ? '-' : ''}${fmt(Math.abs(item.value))}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </Card>
  );
}
